import { useIsHLPPage } from 'helpers/utils/product';
import { useSelector } from 'react-redux';
import { State } from 'store/types';

export const useIsOfferExperimentEnabled = () => {
  const isHlpPage = useIsHLPPage();
  const showOfferCoupons = useSelector(
    (state: State) => state.remoteConfig.switches?.isHlpCouponsAndOffersEnabled
  );
  return isHlpPage && showOfferCoupons;
};
